"use client";

import type { Variant } from "@raumagarn/formatters";
import Image from "next/image";
import { Close } from "~/components/icons/24/Close";
import { usePrice } from "~/lib/hooks/usePrice";
import { formatPrice } from "~/lib/utils/price";
import styles from "./YarnPDPContainer.module.css";

interface YarnPreviewProps {
	yarn: Variant;
	open: boolean;
	onOpenChange: (open: boolean) => void;
}

export const YarnPreview = ({ yarn, open, onOpenChange }: YarnPreviewProps) => {
	const secondImage = yarn.media?.[1] ?? yarn.media?.[0];
	const { price } = usePrice({ pricelist: yarn.pricelist });

	return (
		<div className={styles.yarnPreview}>
			{open && <YarnPreviewMedia yarn={yarn} close={() => onOpenChange(false)} />}
			<div className={styles.collapsedSection}>
				{!!secondImage && (
					<Image
						className={styles.image}
						src={secondImage.href}
						alt={secondImage.alt}
						width={40}
						height={40}
					/>
				)}

				<p>{formatPrice(price)}</p>

				<button onClick={() => onOpenChange(!open)} className={styles.showImages}>
					{open ? "Skjul bilder" : "Se bilder"}
				</button>
			</div>
		</div>
	);
};

const YarnPreviewMedia = ({ yarn, close }: { yarn: Variant; close: () => void }) => {
	return (
		<div className={styles.mediaContainer}>
			<div className={styles.header}>
				<p>{yarn.name}</p>
				<button className={styles.closeButton} onClick={close}>
					<Close />
				</button>
			</div>
			<div className={styles.mediaSlider}>
				{yarn.media?.map((media, index) => (
					<div className={styles.image} key={media.href}>
						<Image fill sizes="80vw" src={media.href} alt={media.alt} />
					</div>
				))}
			</div>
		</div>
	);
};
